import { Outlet, type RouteObject } from 'react-router';

import { metadataRoute, pushRoute } from '@@components/Page/detailViewRoutes';
import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        element: <Outlet />,
        children: [
            {
                index: true,
                lazy: async () => {
                    const { BreakingnewsList } =
                        await import('@@routes/breakingnews/BreakingnewsList');

                    return { Component: BreakingnewsList };
                },
            },
            {
                path: 'new',
                lazy: async () => {
                    const { BreakingnewsSetupPage } = await import('@@routes/breakingnews');

                    return { Component: BreakingnewsSetupPage };
                },
            },
            {
                path: ':id',
                lazy: async () => {
                    const { BreakingnewsDetailPage } = await import('@@routes/breakingnews');

                    return { Component: BreakingnewsDetailPage };
                },
                children: [
                    {
                        index: true,
                        lazy: async () => {
                            const { default: BreakingnewsContent } =
                                await import('@@routes/breakingnews/BreakingnewsContent');

                            return { Component: BreakingnewsContent };
                        },
                        errorElement: <ErrorPage />,
                    },
                    metadataRoute,
                    pushRoute,
                ],
            },
        ],
    },
];
